import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "n-message-composer" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "n-message-composer__actions" }

import { onMounted, ref, nextTick } from 'vue';
import { debounce } from 'lodash';
import autosize from 'autosize';
import NButton from '../../control/button/button.vue';
import NEmojiPicker from '../emoji-picker/emoji-picker.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'n-message-composer',
},
  __name: 'message-composer',
  props: {
  accentColour: {
    type: String,
    default: '#062b80',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["conversationRead", "typingStart", "typingStop", "messageSend"],
  setup(__props, { emit: __emit }) {





const emit = __emit;

const messageText = ref('');

const input = ref<HTMLElement | null>(null);

const selectionStart = ref(0);
const selectionEnd = ref(0);
const isInputFocused = ref(false);
const sentTyping = ref(false);

onMounted(() => {
  autosize(input.value);
});

function onFocus() {
  isInputFocused.value = true;
}

function onBlur(event: any) {
  selectionStart.value = event.target.selectionStart;
  selectionEnd.value = event.target.selectionEnd;
  isInputFocused.value = false;
}

function insertEmoji(emoji: any) {
  messageText.value =
    messageText.value.substring(0, selectionStart.value) +
    emoji.native +
    messageText.value.substring(selectionEnd.value, messageText.value.length);

  nextTick(() => {
    setCursorPosition(selectionStart.value + 2);
    autosize.update(input.value);
  });
}

function onInput() {
  sendConversationRead();

  if (!sentTyping.value) {
    emit('typingStart');
    sentTyping.value = true;
  }
  stopTyping();
}

function setCursorPosition(pos: number) {
  input.value?.focus();
  (input.value as HTMLInputElement).setSelectionRange(pos, pos);
}

function onSend(e: KeyboardEvent): void {
  if (e) {
    e.preventDefault();
  }

  if (!messageText.value.trim().length) {
    messageText.value = '';
    return;
  }

  emit('messageSend', messageText.value);

  // cancel the stop typing event so we don't send stop typing after we've sent the message
  sentTyping.value = false;

  messageText.value = '';

  // reset height of textarea (in case it had to grow to accommodate text)
  nextTick(() => {
    autosize.update(input.value);
  });
}

function getOpacity() {
  if (messageText && messageText.value.length === 0) {
    return 0.4;
  }
  return 1;
}

function sendConversationRead() {
  emit('conversationRead');
}

function sendTypingStop() {
  emit('typingStop');
}

const stopTyping = debounce(() => {
  sendTypingStop();
  sentTyping.value = false;
}, 10000);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["n-message-composer__input-container", {
        'n-message-composer__input-container--focused': isInputFocused.value,
        'n-message-composer__input-container--disabled': __props.disabled,
      }])
    }, [
      _withDirectives(_createElementVNode("textarea", {
        ref_key: "input",
        ref: input,
        class: "n-message-composer__input",
        rows: "1",
        placeholder: "Enter your message...",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((messageText).value = $event)),
        disabled: __props.disabled,
        onInput: _cache[1] || (_cache[1] = ($event: any) => (onInput())),
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (onFocus())),
        onBlur: onBlur,
        onKeypress: _withKeys(onSend, ["enter"])
      }, null, 40, _hoisted_2), [
        [_vModelText, messageText.value]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(NEmojiPicker, {
          onEmojiSelect: insertEmoji,
          accentColour: __props.accentColour
        }, null, 8, ["accentColour"]),
        _createVNode(NButton, {
          icon: "send",
          variant: "action",
          disabled: messageText.value && messageText.value.length === 0,
          onClick: onSend
        }, null, 8, ["disabled"])
      ])
    ], 2)
  ]))
}
}

})